import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import {
  fetchRegisteredData,
  fetchTabGridData,
  fetchTabKeywordGridData,
  fetchKeywordAddDel,
  fetchKeywordDeleteAll,
  fetchRegisteredKeywordDelete,
  // 탭 키워드 데이터
  fetchAppleAutoFillData,
  fetchGooglePlaySuggestionData,
  fetchSimilarKeywordData,
  fetchSearchAdsRecommendedData,
  fetchRelatedKeywordData,
  fetchTrendingKeywordData,
} from './thunk/suggestionThunk';
import { addDelKeywordParamsType } from '@models/keyword/keywordModel';
import { keywordAddDelType } from './thunk/suggestionThunk';
import { tabInfoDataFrame } from '@configs/keyword'; //이건 리덕스에서 넣기

export type tabDataParamsType = {
  keyword: string;
  country: string;
};

type groupHandlerParamsType = {
  tabIndex: number;
  updatedData: any;
};

const initialState = {
  tabInfoData: null, // tab 정보
  tabKeywordList: null, // tab 선택시 keywordGrid 데이터 정보 TODO: 추후 삭제할것..
  registerdKeywordList: null, // registeredGridData
  keyword: null, // registeredGridData 클릭시 keyword
};

export const keywordSuggestionSlice = createSlice({
  name: 'keywordSuggestion',
  initialState: initialState,
  reducers: {
    // tabData 틀 주입하기 TODO: 여기서부터 내일하기.
    setInitialTabDataFrame: (state, { payload }) => {
      state.tabInfoData = tabInfoDataFrame;
    },
    // tabResultKeywordList 그리드 데이터
    dispatchGroupHandler: (state, { payload }: { payload: groupHandlerParamsType }) => {
      const { tabIndex, updatedData } = payload;
      // state.tabKeywordList = payload.payload;
      state.tabInfoData[tabIndex] = updatedData;
    },
    // registeredKeyword의 keyword 클릭시 아래처리
    clickedKeyword: (state, { payload }: { payload: { keyword: string } }) => {
      state.keyword = payload.keyword;
    },
  },
  extraReducers: {
    // registered Data
    [fetchRegisteredData.fulfilled.type]: (state, { payload }) => {
      state.registerdKeywordList = payload;
    },
    // tab Data
    [fetchTabGridData.fulfilled.type]: (state, { payload }) => {
      state.tabInfoData = payload;
    },
    // tab keywordGridData
    [fetchTabKeywordGridData.fulfilled.type]: (state, { payload }) => {
      state.tabKeywordList = payload;
    },
    // keyword Add/Del
    [fetchKeywordAddDel.fulfilled.type]: (state, { payload }: { payload: keywordAddDelType }) => {
      const { tabIndex, keywordObj, reqTrackedType } = payload;
      console.log('params777: ', payload);
      // // 로직
      // // 다시 요청 받은 registered Data 리덕스에 넣기
      // state.registerdKeywordList = registeredData;
      // // add/del 키워드 부분 로직
      // const { tabIndex, keyword, reqType, group } = params;
      // const objIndex = state.tabKeywordList.findIndex((item) => item.keyword === keyword);
      // // request가 add 이므로 del 로 바꿔야 한다.(true)
      // if (reqType === 'add') {
      //   state.tabKeywordList[objIndex].tracked = true;
      // } else if (reqType === 'del') {
      //   // request가 del 이므로 add로 바꿔야 한다.(false)
      //   state.tabKeywordList[objIndex].tracked = false;
      // }

      // 바뀐 로직
      // 1. 기존의 tabInfoData 의 해당 탭 데이터를(add/del) 변경해야한다. (group 도 변경처리)
      // 2. registerdKeywordList에 데이터를 추가해야 한다.
      // 1)
      const objIndex = state.tabInfoData[tabIndex]['keywordDataList'].findIndex(
        (item) => item.keyword === keywordObj.keyword
      );
      state.tabInfoData[tabIndex]['keywordDataList'][objIndex].tracked = !keywordObj?.tracked;
      state.tabInfoData[tabIndex]['keywordDataList'][objIndex].group = keywordObj?.group;
      // 2)
      if (reqTrackedType === 'add') {
        state.registerdKeywordList.push({
          ...keywordObj,
          apps: 0,
          brand: false,
        });
      } else if (reqTrackedType === 'del') {
        state.registerdKeywordList = state.registerdKeywordList.filter((item) => item.keyword !== keywordObj.keyword);
      }

      // "keyword": "nisi",
      // "group": "group1",
      // "brand": true,
      // "searchscore": 28,
      // "apps": 985,
      // "chance": 0.8532
    },
    // registered keyword delete one
    [fetchRegisteredKeywordDelete.fulfilled.type]: (state, { payload }) => {
      const { keyword, keywordId } = payload;
      // registeredList filter로 삭제처리
      state.registerdKeywordList = state.registerdKeywordList.filter((item) => item.keyword !== keyword);
      // tabKeywordList keywordlist 변경하기
      if (state.tabKeywordList) {
        const objIndex = state.tabKeywordList.findIndex((item) => item.keyword === keyword);
        if (objIndex > -1) {
          state.tabKeywordList[objIndex].tracked = false;
        }
      }
    },
    // registered Keyword DeleteAll
    [fetchKeywordDeleteAll.fulfilled.type]: (state, { payload }) => {
      // registerdKeywordList 은 null 로 초기화처리
      state.registerdKeywordList = null;
      // tabGridData와 일치하는건 tracked false 처리해두기
      if (state.tabKeywordList) {
        const sameKeywordList = state.tabKeywordList.filter((item) => payload.includes(item.id));
        if (sameKeywordList.length > 0) {
          sameKeywordList.forEach((sameObj) => {
            const objIndex = state.tabKeywordList.findIndex((keywordObj) => keywordObj.id === sameObj.id);
            state.tabKeywordList[objIndex].tracked = false;
          });
        }
      }
    },
    //// tab 관련 데이터 응답 처리
    // appleAutoFill
    [fetchAppleAutoFillData.fulfilled.type]: (state, { payload }) => {
      console.log('appleAutoFill fulfilled paylaod: ', payload);
      console.log('state.registerdKeywordList: ', state.registerdKeywordList);
      state.tabInfoData[0]['keywordDataList'] = payload.map((item) => {
        const objIndex = state.registerdKeywordList.findIndex(
          (registeredObj) => registeredObj.keyword === item.keyword
        );
        return {
          ...item,
          tracked: objIndex > -1 ? true : false,
          group: objIndex > -1 ? state.registerdKeywordList[objIndex].group ?? null : null,
        };
      });
      // // 아래의 두 항목은 slice 에서 처리하기
      // tracked: objIndex > -1 ? true : false,
      // group: objIndex > -1 ? registeredKeywordList[objIndex].group ?? null : null,
    },
    [fetchAppleAutoFillData.rejected.type]: (state, { payload }) => {
      console.log('appleAutoFill rejected payload: ', payload);
      state.tabInfoData[0]['keywordDataList'] = payload;
    },
    // googlePlaySuggestion
    [fetchGooglePlaySuggestionData.fulfilled.type]: (state, { payload }) => {
      console.log('fetchGooglePlaySuggestionData fulfilled payload: ', payload);
      state.tabInfoData[1]['keywordDataList'] = payload.map((item) => {
        const objIndex = state.registerdKeywordList.findIndex(
          (registeredObj) => registeredObj.keyword === item.keyword
        );
        return {
          ...item,
          tracked: objIndex > -1 ? true : false,
          group: objIndex > -1 ? state.registerdKeywordList[objIndex].group ?? null : null,
        };
      });
      // // 아래의 두 항목은 slice 에서 처리하기
      // tracked: objIndex > -1 ? true : false,
      // group: objIndex > -1 ? registeredKeywordList[objIndex].group ?? null : null,
    },
    [fetchGooglePlaySuggestionData.rejected.type]: (state, { payload }) => {
      state.tabInfoData[1]['keywordDataList'] = payload;
    },
    // similar keywords
    [fetchSimilarKeywordData.fulfilled.type]: (state, { payload }) => {
      state.tabInfoData[3]['keywordDataList'] = payload.map((item) => {
        const objIndex = state.registerdKeywordList.findIndex(
          (registeredObj) => registeredObj.keyword === item.keyword
        );
        return {
          ...item,
          tracked: objIndex > -1 ? true : false,
          group: objIndex > -1 ? state.registerdKeywordList[objIndex].group ?? null : null,
        };
      });
      // // 아래의 두 항목은 slice 에서 처리하기
      // tracked: objIndex > -1 ? true : false,
      // group: objIndex > -1 ? registeredKeywordList[objIndex].group ?? null : null,
    },
    [fetchSimilarKeywordData.rejected.type]: (state, { payload }) => {
      state.tabInfoData[3]['keywordDataList'] = payload;
    },
    // searchAdsRecommended keywords
    [fetchSearchAdsRecommendedData.fulfilled.type]: (state, { payload }) => {
      console.log('fetchSearchAdsRecommendedData payload: ', payload);
      state.tabInfoData[2]['keywordDataList'] = payload;
    },
    [fetchSearchAdsRecommendedData.rejected.type]: (state, { payload }) => {
      state.tabInfoData[2]['keywordDataList'] = payload;
    },
    // relatedKeyword keywords
    [fetchRelatedKeywordData.fulfilled.type]: (state, { payload }) => {
      state.tabInfoData[4]['keywordDataList'] = payload;
    },
    [fetchRelatedKeywordData.rejected.type]: (state, { payload }) => {
      state.tabInfoData[4]['keywordDataList'] = payload;
    },
    // TrendingKeyword
    [fetchTrendingKeywordData.fulfilled.type]: (state, { payload }) => {
      state.tabInfoData[5]['keywordDataList'] = payload;
    },
    [fetchTrendingKeywordData.rejected.type]: (state, { payload }) => {
      state.tabInfoData[5]['keywordDataList'] = payload;
    },
  },
});

export const { clickedKeyword, dispatchGroupHandler, setInitialTabDataFrame } = keywordSuggestionSlice.actions;
export const keywordSuggestionSliceName = keywordSuggestionSlice.name;
export default keywordSuggestionSlice.reducer;
